/**
 * @typedef {Object} CustomSwitchProps
 * @property {React.ReactNode} [label] To add label to the switch
 * @property {Object} [classes] To add custom class to the Label
 * @property {string} [classes.wrapper] To add custom class to the wrapper
 * @property {string} [classes.label] To add custom class to the label
 * @property {string} [classes.switch] To add custom class to the switch
 * @property {Object} [labelProps] To add custom props to the label
 * @property {boolean} [labelProps.required]  to display the *
 
 */

/**
 * @typedef {import('antd').SwitchProps} SwitchProps
 */

import React from 'react';

import cx from 'classnames';
import { Switch as SwitchCore } from 'antd';

import styles from './Switch.module.scss';

import { InputLabel } from '.';

/**
 * @description UI Component to display the Switch element. Underlying it is using the antd Switch component.
 *
 * @author  Akshay Jain <@akshay.jain2>
 *
 * @reference https://ant.design/components/switch
 *
 * @param {SwitchProps & CustomSwitchProps}  props https://ant.design/components/switch
 *
 * @returns {React.JSX}
 */

const Switch = (props) => {
	const { label, labelProps = {}, classes = {}, id, ...otherProps } = props;
	const {
		wrapper = '',
		label: labelClass = '',
		switch: switchClass = '',
	} = classes;

	return (
		<div className={cx(styles.switchWrapper, wrapper)}>
			<SwitchCore id={id} className={switchClass} {...otherProps} />
			<InputLabel
				className={cx(styles.label, labelClass)}
				htmlFor={id}
				{...labelProps}
			>
				{label}
			</InputLabel>
		</div>
	);
};

export default Switch;
